export class AbstractExternalContact {
  id?: number;
  version?: number;

  subtype: string;
  firstName: string;
  lastName: string;
  fullName: string;
  title: string;
  officePhone: string;
  officePhoneExt: number;
  mobilePhone: string;
  faxPhone: string;
  email: string;
  contactType: string;

  addressId: number;
  partnerId: number;

  addrName: string;
}
